export default __webpack_public_path__ + "static/media/broken-robot.c3b425b8.png";